var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon34(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M60,8c2.8,0,5.6,0.4,8.2,1.1L48.5,28.7l-5.7,5.7l5.7,5.7l11.3,11.3l5.7,5.7l5.7-5.7l19.7-19.7 c0.7,2.7,1.1,5.5,1.1,8.4c0,17.6-14.4,32-32,32c-3.4,0-6.8-0.5-10-1.6l-4.7-1.5l-3.5,3.5L23.3,90.8c-1,1-2.2,1.2-2.8,1.2 c-0.6,0-1.8-0.2-2.8-1.2l-8.5-8.5c-1-1-1.2-2.2-1.2-2.8c0-0.6,0.2-1.8,1.2-2.8l18.5-18.5l3.5-3.5L29.6,50c-1.1-3.2-1.6-6.6-1.6-10 C28,22.3,42.4,8,60,8 M60,0C37.9,0,20,17.9,20,40c0,4.4,0.7,8.6,2,12.5L3.5,71c-4.7,4.7-4.7,12.3,0,17l8.5,8.5 c2.3,2.3,5.4,3.5,8.5,3.5s6.1-1.2,8.5-3.5L47.5,78c3.9,1.3,8.2,2,12.6,2c22.1,0,40-17.9,40-40c0-8.2-2.5-15.8-6.7-22.1L65.5,45.7 L54.2,34.4L82,6.6C75.7,2.4,68.1,0,60,0L60,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon34);
export default __webpack_public_path__ + "static/media/motion_icon-34.c99995cf.svg";
export { ForwardRef as ReactComponent };